<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>
            <div class="grid md:grid-cols-3 gap-4">
                <div class="md:col-span-2 md:mb-6">
                    <h1 class="mb-2">{{ this.model.name }}</h1>
                    <Tabs>
                        <div v-for="tab in model.tabsWithItems" :key="tab.id">
                            <Tab :title="tab.tabTitle">
                                <ul class="bg-white -mt-5 p-4">
                                    <li v-for="item in tab.tabItems" :key="item.id" :id="item.id">
                                        <Accordion :title="item.name" :preopen="openShortcut(item.id)">
                                            <div v-if="item.intro" v-html="item.intro" class="mb-8 article"></div>
                                            <div v-if="item.mainBody" v-html="item.mainBody" class="mb-8 article"></div>
                                            <div class="mb-8">
                                                <a :href="`#${item.id}`" title="Snarvei" class="text-gray-400 hover:text-gray-800">
                                                    <font-awesome-icon class="" icon="link" />
                                                </a>
                                            </div>
                                        </Accordion>
                                    </li>
                                </ul>
                            </Tab>
                        </div>
                    </Tabs>
                </div>
                <aside>
                    <div class="inline-block w-full mb-6 bg-white">
                        <div class="flex justify-end mt-6">
                            <Sharing />
                        </div>
                    </div>
                </aside>
            </div>
        </div>
</DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import Tab from '@/Scripts/components/atoms/Tabs/Tab.vue';
import Tabs from '@/Scripts/components/atoms/Tabs/Tabs.vue';
import Accordion from '@/Scripts/components/atoms/Accordion/Accordion.vue';
import Sharing from '@/Scripts/components/atoms/Sharing/Sharing.vue';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        Tab,
        Tabs,
        Accordion,
        Sharing
    },
    methods: {
        openShortcut(id) {
            let hash = window.location.hash;
            hash = hash.substring(1);
            if (id === hash) {
                return true;
            }
            return false;
        }
    }
};
</script>
